// @ts-nocheck
/* eslint-disable */
export const stdDotIcon = {
    data: `<?xml version="1.0" encoding="UTF-8"?><svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><circle cx="12" cy="12" r="10" fill="currentColor"/></svg>`,
    name: 'dot' as const
};